<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header mt-0" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center"
      (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>

    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'"
      class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>

  <div class="check-class" *ngIf="!isViewAll">
    <nz-radio-group [(ngModel)]="objectChoosing.isInStock" (ngModelChange)="
        vhEventMediator.notifyOnConfigChanged({
          _id: this.objectChoosing._id,
          changeActive: true
        })
      ">
      <label nz-radio *ngFor="let item of status" [nzValue]="item.type"><span>{{ item.title | translate }}</span></label>
    </nz-radio-group>
  </div>

  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-text" style="width: 100%">
        <mat-form-field style="width: 100%">
          <mat-label>{{'noi_dung' | translate}}</mat-label>
          <textarea matInput
            [ngModel]="staticdata[(objectChoosing.isInStock ? '+' : '-') + 'content_' + functionService.selectedLanguageCode] | vhLanguage : (objectChoosing.isInStock ? 'Còn hàng' : 'Hết hàng') : objectChoosing.component"
            (ngModelChange)="staticdata[(objectChoosing.isInStock ? '+' : '-') + 'content_' + functionService.selectedLanguageCode] = $event"
            (blur)="updateContent((objectChoosing.isInStock ? '+' : '-') + 'content')"></textarea>
        </mat-form-field>
      </div>
      <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class" [config]="config"
        [staticdata]="staticdata" [textContentClass]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']"
        [textWrapperClass]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']">
      </app-text-format-config>
      <div class="config-name">
        <p>{{'xuong_dong' | translate}}</p>
        <nz-switch
          [ngModel]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']['white-space'] && class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']['white-space'] !== 'nowrap'"
          (ngModelChange)="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
      </div>
    </div>
  </ng-container>
 
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->


      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <div class="config-text" style="width: 100%">
              <mat-form-field style="width: 100%">
                <mat-label>{{'noi_dung' | translate}}</mat-label>
                <textarea matInput
                  [ngModel]="staticdata[(objectChoosing.isInStock ? '+' : '-') + 'content_' + functionService.selectedLanguageCode] | vhLanguage : (objectChoosing.isInStock ? 'Còn hàng' : 'Hết hàng') : objectChoosing.component"
                  (ngModelChange)="staticdata[(objectChoosing.isInStock ? '+' : '-') + 'content_' + functionService.selectedLanguageCode] = $event"
                  (blur)="updateContent((objectChoosing.isInStock ? '+' : '-') + 'content')"></textarea>
              </mat-form-field>
            </div>
            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config" [staticdata]="staticdata"
              [textContentClass]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']"
              [textWrapperClass]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']">
            </app-text-format-config>
            <div class="config-name">
              <p>{{'xuong_dong' | translate}}</p>
              <nz-switch
                [ngModel]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']['white-space'] && class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']['white-space'] !== 'nowrap'"
                (ngModelChange)="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__wrapper']['white-space'] = $event ? 'pre-wrap' : 'nowrap';updateClass()"></nz-switch>
            </div>
            <!-- Gradient -->
            <div class="config-font">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <p class="m-0" style="line-height:1.5">{{"do_mau_gradient" | translate}} <span
                    style="font-size:13px">({{"da_sac" | translate}})</span></p>
                <nz-switch
                  [(ngModel)]="config[(objectChoosing.isInStock ? '+' : '-') + 'background-image'].gradient_check"
                  (ngModelChange)="handleSetGradientText()">
                </nz-switch>
              </div>
              <div class="container-gradient"
                *ngIf="config[(objectChoosing.isInStock ? '+' : '-') + 'background-image'].gradient_check">
                <div class="list-gradient">
                  <button class="btn-gradient"
                    *ngFor="let bgGradient of config[(objectChoosing.isInStock ? '+' : '-') + 'background-image']['gradient_arr_gradient']; let i = index"
                    (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                    [disabled]="!config[(objectChoosing.isInStock ? '+' : '-') + 'background-image'].gradient_check">
                    <i class="delete-icon bi bi-x-circle"></i>
                  </button>
                </div>
                <p class="title-head">{{ 'them_mau' | translate }}</p>
                <div class="container_add-gradient">
                  <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                    [disabled]="!config[(objectChoosing.isInStock ? '+' : '-') + 'background-image'].gradient_check"
                    (click)="openbgGradient()" (blur)="addGradient()">
                    <input nz-input type="color" class="picking-gradient" id="input-gradient"
                      [(ngModel)]="config[(objectChoosing.isInStock ? '+' : '-') + 'background-image']['gradient_background_color']">
                    <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                  </button>
                  <div class="slide_container-gradient">
                    <input type="range" min="1" max="100"
                      [value]="config[(objectChoosing.isInStock ? '+' : '-') + 'background-image']['gradient_opacity']"
                      class="slider-gradient" (input)="getValueRangeBackgroundGradient($event)"
                      [disabled]="!config[(objectChoosing.isInStock ? '+' : '-') + 'background-image'].gradient_check"
                      [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                  </div>
                  <div class="value-range">{{config[(objectChoosing.isInStock ? '+' : '-') +
                    'background-image']['gradient_opacity']}}%</div>
                </div>
                <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip
                  [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                  [disabled]="!config[(objectChoosing.isInStock ? '+' : '-') + 'background-image'].gradient_check"
                  [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                  [ngClass]="{ 'active': config[(objectChoosing.isInStock ? '+' : '-') + 'background-image']['gradient_direction'] === type.direction}">
                </button>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']['letter-spacing'] | vhnumber"
                      (nzBlur)="updateClass()"
                      (ngModelChange)="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']['line-height']"
                      (nzBlur)="updateClass()" [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="10" [nzStep]="0.1"
                        [(ngModel)]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config [config]="config" [class]="class" [staticdata]="staticdata" [device]="device"
          [objectChoosing]="objectChoosing"
          [textContentClass]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name__content']"
          [textWrapperClass]="class[(objectChoosing.isInStock ? '+' : '-') + 'text-name']"
          [filterConfig]="config[(objectChoosing.isInStock ? '+' : '-') + 'text-shadow']" [isShape]="false">
        </app-text-style-config>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['+text-name']" [cursorClass2]="class['-text-name']"
          [titleCursor]="{ cursor1: 'con_tro_khi_con_hang', cursor2: 'con_tro_khi_het_hang' }"
          [effect_hover]="effect_hover" [customize]="customize" [type]="'object'" [effectFileUsing]="'text'">
        </app-choose-animations-config>
      </li>
      <!-- THÊM LIÊN KẾT -->
      <li nz-submenu nzTitle="{{'lien_ket' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-link-page-config [type_page]="['detail_product']" [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000' && currentViewAll.index == 2">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>